<script>
import gtm from '@/core/enhanced-ecommerce-gtm'

export default {
  props: {
    productCode: {
      type: String,
      default: null
    },
    variantCode: {
      type: String,
      default: null
    },
    brand: {
      type: String,
      default: null
    }
  },
  mounted() {
    const { productCode, variantCode, brand } = this
    const item = {
      item_id: productCode
    }
    if (variantCode) item.item_variant = variantCode
    if (brand) item.item_brand = brand

    gtm.addViewItem({ items: [item] })
  },
  render: function() {
    return ''
  }
}
</script>
